import { Text, TextProps } from '@chakra-ui/core';
import React, { memo } from 'react';

export const MismatchBadge = memo(function MismatchBadge(props: TextProps): JSX.Element {
  return (
    <Text as="span" color="red.500" fontWeight="bold" display="inline" {...props}>
      !
    </Text>
  );
});
